import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import HubHeader from '../../components/ui/HubHeader';
import Seo from '../../components/Seo';
import { JessicaMobileHandoffCard } from '../../components/agency/JessicaMobileHandoffCard';
import { getOuroMobileShellUrl, OURO_APP_NAME } from '../../lib/ouroMobileUrl';

const agencySans = "font-[Calibri,'Calibri_Light','Segoe_UI',sans-serif]";

const ouroHeroGradient =
  'linear-gradient(145deg, #faf5ff 0%, #f3e8ff 42%, #ede9fe 100%)';

export default function OuroMobileHandoffPage() {
  const mobileUrl = getOuroMobileShellUrl();

  return (
    <>
      <Seo
        title={`${OURO_APP_NAME} on your phone | Neevii`}
        description={`Scan the QR code to open ${OURO_APP_NAME} in a full-screen mobile shell. Add to your home screen for quick access.`}
      />
      <div className={`min-h-screen ${agencySans}`} style={{ background: ouroHeroGradient }}>
        <HubHeader />
        <main className="mx-auto max-w-3xl px-5 pb-16 pt-28 sm:px-8 sm:pt-32">
          <Link
            to="/agency"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#6d28d9] transition-colors hover:text-[#5b21b6]"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden />
            Back to Agency
          </Link>

          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-[#7c3aed]">
            {OURO_APP_NAME}
          </p>
          <h1 className="mt-2 text-3xl font-semibold leading-tight text-neutral-900 sm:text-4xl">
            Open {OURO_APP_NAME} on your phone
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-neutral-600 sm:text-lg">
            This is the real mobile shell — full screen, touch-first, and ready to pin to your home screen.
            Scan the code below or open the link on your phone.
          </p>

          <div className="mt-8">
            <JessicaMobileHandoffCard />
          </div>

          <section className="mt-8 rounded-2xl border border-white/70 bg-white/70 p-5 backdrop-blur-sm sm:p-6">
            <h2 className="text-lg font-semibold text-neutral-900">Add to home screen</h2>
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <div>
                <p className="text-sm font-semibold text-neutral-800">iPhone (Safari)</p>
                <p className="mt-1 text-sm leading-relaxed text-neutral-600">
                  Open <span className="break-all text-neutral-700">{mobileUrl}</span>, tap Share, then
                  {' '}<strong>Add to Home Screen</strong>.
                </p>
              </div>
              <div>
                <p className="text-sm font-semibold text-neutral-800">Android (Chrome)</p>
                <p className="mt-1 text-sm leading-relaxed text-neutral-600">
                  Open the link, tap the menu (⋮), then <strong>Add to Home screen</strong> or
                  {' '}<strong>Install app</strong> when offered.
                </p>
              </div>
            </div>
          </section>

          <p className="mt-6 text-sm text-neutral-500">
            Desktop showcase still available on the{' '}
            <Link to="/agency" className="font-medium text-[#6d28d9] underline-offset-2 hover:underline">
              Agency page
            </Link>
            .
          </p>
        </main>
      </div>
    </>
  );
}

/** @deprecated Use default export OuroMobileHandoffPage */
export const JessicaMobileHandoffPage = OuroMobileHandoffPage;
